import { render, staticRenderFns } from "./storeSetting.vue?vue&type=template&id=a8ad0e4e&scoped=true&"
import script from "./storeSetting.vue?vue&type=script&lang=js&"
export * from "./storeSetting.vue?vue&type=script&lang=js&"
import style0 from "./storeSetting.vue?vue&type=style&index=0&id=a8ad0e4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ad0e4e",
  null
  
)

export default component.exports